import { Workbook, DataBind } from '../index';
import { WorkbookSave, WorkbookFormula, WorkbookOpen, WorkbookSort, WorkbookFilter } from '../integrations/index';
import { WorkbookNumberFormat } from '../integrations/number-format';
import { WorkbookEdit, WorkbookCellFormat, WorkbookHyperlink, WorkbookInsert, WorkbookDelete } from '../actions/index';
import { WorkbookFindAndReplace, WorkbookProtectSheet, WorkbookDataValidation, WorkbookMerge } from '../actions/index';
/**
 * Workbook basic module.
 * @private
 */
var WorkbookBasicModule = /** @class */ (function () {
    /**
     * Constructor for Workbook basic module.
     * @private
     */
    function WorkbookBasicModule() {
        Workbook.Inject(DataBind, WorkbookSave, WorkbookOpen, WorkbookNumberFormat, WorkbookCellFormat, WorkbookEdit, WorkbookFormula, WorkbookSort, WorkbookHyperlink, WorkbookFilter, WorkbookInsert, WorkbookDelete, WorkbookFindAndReplace, WorkbookProtectSheet, WorkbookDataValidation, WorkbookMerge);
    }
    /**
     * For internal use only - Get the module name.
     * @private
     */
    WorkbookBasicModule.prototype.getModuleName = function () {
        return 'workbookBasic';
    };
    /**
     * Destroys the Workbook basic module.
     * @return {void}
     */
    WorkbookBasicModule.prototype.destroy = function () {
        /* code snippet */
    };
    return WorkbookBasicModule;
}());
export { WorkbookBasicModule };
